export default __webpack_public_path__ + "static/vbd_onboarding.60ae7ee9f713ec7886cff4069a32850f.png";